import React from 'react';
import { ArrowRight } from 'lucide-react';

const IndustryCTA = ({ industry }) => {
  return (
    <section className="relative py-24 sm:py-32 overflow-hidden" style={{ background: '#F8FAFC' }}>
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px]" style={{ background: 'radial-gradient(circle, rgba(38,147,255,0.06) 0%, transparent 70%)' }} />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-900 font-heading mb-5 leading-tight">
          Ready to transform your {industry.toLowerCase()} business?
        </h2>
        <p className="text-lg text-slate-500 mb-10 max-w-2xl mx-auto leading-relaxed">
          Let's discuss how we can help you build innovative digital solutions
        </p>
        <a
          href="#contact"
          className="btn-gradient inline-flex items-center gap-2.5 px-8 py-4 rounded-full text-white font-semibold text-base cursor-pointer group"
          style={{ boxShadow: '0 8px 30px rgba(38,147,255,0.3)' }}
        >
          Get in touch
          <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
        </a>
      </div>
    </section>
  );
};

export default IndustryCTA;
